// External packages
import * as ReactAria from 'react-aria-components';

// Utils
import { twMerge } from 'tailwind-merge';

export const Tabs: React.FC<ReactAria.TabsProps> = ({
  className,
  ...props
}) => (
  <ReactAria.Tabs
    className={twMerge(
      'group flex flex-col border border-gray-300 rounded-lg data-[orientation=vertical]:flex-row',
      className as string
    )}
    {...props}
  />
);

export const TabList: React.FC<ReactAria.TabListProps<object>> = ({
  className,
  ...props
}) => (
  <ReactAria.TabList
    {...props}
    className={twMerge(
      'flex group-data-[orientation=vertical]:flex-col group-data-[orientation=horizontal]:justify-between group-data-[orientation=horizontal]:border-b-2 group-data-[orientation=vertical]:border-r-2 border-gray-300',
      className as string
    )}
  />
);

export const Tab: React.FC<ReactAria.TabProps> = ({ className, ...props }) => (
  <ReactAria.Tab
    {...props}
    className={twMerge(
      'cursor-pointer whitespace-nowrap px-4 py-2 relative text-gray-600 after:absolute after:bottom-0 after:content-[""] group-data-[orientation=vertical]:after:-right-0.5 after:right-0 after:w-full group-data-[orientation=vertical]:after:w-0.5 group-data-[orientation=vertical]:after:h-full after:h-0.5 data-selected:after:bg-blue-500 after:bg-transparent after:transition-colors data-disabled:cursor-not-allowed data-disabled:opacity-50 transition',
      className as string
    )}
  />
);

export const TabPanel: React.FC<ReactAria.TabPanelProps> = ({
  className,
  ...props
}) => (
  <ReactAria.TabPanel
    {...props}
    className={twMerge(
      'w-full group-data-[orientation=vertical]:ml-6 group-data-[orientation=vertical]:mt-2',
      className as string
    )}
  />
);
